import React from 'react';
import Linklist from '../platformui/Linklist';
import SectionWrapper from '../platformui/ListContainer/section-wrapper';
import * as Render from '../platformui/Base/Render';

export default (props) => {
  switch (props.CurrentPageProps.PageTypeName) {
    case 'CollectionPage':
      return (
        <SectionWrapper>
          <Linklist
            Modifiers={{ 'c-linklist--block': true }}
            {...props}
            Heading={Render.Property(props.Heading, 'Heading')}
          />
        </SectionWrapper>
      );

    default:
      return (
        <Linklist
          Modifiers={{ 'c-linklist--block': true }}
          {...props}
          Heading={Render.Property(props.Heading, 'Heading')}
        />
      );
  }
};
